import { render, staticRenderFns } from "./adverseEventReport.vue?vue&type=template&id=365448ae&scoped=true"
import script from "./adverseEventReport.vue?vue&type=script&lang=js"
export * from "./adverseEventReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365448ae",
  null
  
)

export default component.exports